export default {
    GOOGLE_CLIENT_ID: process.env.AUTH_SOCIAL_GOOGLE_CLIENT_ID || '',
    prefixReducer: 'pakado'
};
